import { Cache } from 'aws-amplify/utils'
import { fetchAuthSession } from 'aws-amplify/auth'

async function getToken() {
  // Refresh session in Cache. Set expiry to 1 hour from now.
  const now = new Date()
  Cache.setItem('Session', now, { expires: now.setHours(now.getHours() + 1) })

  // Get current session (v6)
  const { tokens } = await fetchAuthSession()
  const token = tokens?.idToken?.toString()
  return token
}

export default getToken
